import { Divider, Grid, Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import StageAssigneeTable from './StageAssigneeTable';
import TasksTable from './TasksTable';
import AttachmentsTable from './AttachmentsTable';
import SignaturesTable from './SignaturesTable';
import React, { useState } from 'react';
import CustomField from './CustomField';

function CustomFieldRow(customField) {
  if (customField.type === 'plain_text') {
    return (
      <Grid.Row className="plain-text-type">
        <CustomField value={customField.value} type={customField.type} className="custom-field-value"></CustomField>
      </Grid.Row>
    );
  }
  return (
    <Grid.Row>
      <Grid.Column width={8} className="custom-field-label">
        {customField.label}
      </Grid.Column>
      <CustomField value={customField.value} type={customField.type} className="custom-field-value"></CustomField>
    </Grid.Row>
  );
}

export default function StageData({ stageData }) {
  const name = stageData?.name;
  const due_date = stageData.due_date;
  const assignees = stageData?.stageAssignees;
  const tasks = stageData?.tasks;
  const attachments = stageData?.attachments;
  const customFields = stageData?.customFields;
  const signatures = stageData?.signatures;
  const isCurrentStage = stageData?.isCurrentStage || false;
  const [showSection, setShowSection] = useState(isCurrentStage);

  const toggleSection = () => {
    setShowSection(!showSection);
  };

  return (
    <div className="stage-details">
      {showSection ? (
        <div className="section-header" onClick={toggleSection}>
          <Icon name="chevron up" inline="true" data-testid="chevron-up-icon" />
          {name}
        </div>
      ) : (
        <div className="section-header" onClick={toggleSection}>
          <Icon name="chevron down" inline="true" data-testid="chevron-down-icon" />
          {name}
        </div>
      )}
      {showSection && (
        <div className="section-body">
          <Grid stackable className="stage-due-date">
            <Grid.Row>
              <Grid.Column width={8} className="custom-field-label">
                <FormattedMessage id="stageData.stageDueDate" defaultMessage="Stage Due Date" />
              </Grid.Column>
              <CustomField value={due_date} type={'date'}></CustomField>
            </Grid.Row>
          </Grid>
          <StageAssigneeTable stageAssignees={assignees} />
          <TasksTable tasks={tasks} isIssueDetail={false} />
          <AttachmentsTable attachments={attachments} />
          <Grid stackable className="custom-fields">
            {customFields?.map((customField) => {
              return CustomFieldRow(customField);
            })}
          </Grid>
          <SignaturesTable signatures={signatures} />
        </div>
      )}
      <Divider></Divider>{' '}
    </div>
  );
}
